import { useSelector } from "react-redux";
import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";

import { selectActiveItem } from "Store/Selectors/Projects";
import { getAddress } from "Utils/Address";
import { useSubHeaderStyles } from "./UseSubHeaderStyles";
import { RelevanceActionButton } from "../RelevanceActionButton";

export function SubHeader(): JSX.Element {
  const item = useSelector(selectActiveItem);
  const styles = useSubHeaderStyles();
  return (
    <Stack horizontal verticalAlign="center" className={styles.root}>
      <Stack.Item>
        <RelevanceActionButton item={item} />
      </Stack.Item>
      <Stack.Item>
        <Text>{getAddress(item)}</Text>
      </Stack.Item>
    </Stack>
  );
}
